import React from 'react'
import { CallToAction } from 'components/Buttons/Buttons'
import { DataBrowser } from 'components/Data/Data'

export default class Browser extends React.Component {
    render() {
        const Data = DataBrowser();
        return (
            <section className="category-section browser">

                <div className="ghost-image"></div>

                <div className="centered">

                    <h3 className="section-title">{Data.browser.categoryName}</h3>
                    <p className="section-description">{Data.browser.categoryDescription}</p>

                    <div className="item">
                        <figure>
                            <img src={require("assets/images/browser-hero-image.svg")} alt="Sketchize: Web Browser Template" />
                            <span className="decorative-text right">SKETCH FOR<br />DESKTOP BROWSER</span>
                        </figure>
                        <h4 className="hero-item-title">{Data.browser.title}</h4>
                        <p className="hero-item-description">{Data.browser.description}</p>
                    </div>{/* .item */}

                    <CallToAction clickid="download-browser" link={"https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/browser.zip"} content="DOWNLOAD MORE" />

                </div>{/* .centered */}
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/MainSections/Browser/Browser.js